import {black, gray, white} from './colors/shades';

const info = `#03B7CE`;
const deepTeal = `#039cad`;
const primaryBackground = `rgba(46, 120, 199, 0.08)`;
const textPrimary = gray[800];

/**
 * Old colors used before creating foundation colors.
 *
 * Please use foundation instead. This will be removed once we factor out all
 * legacy colors into foundations.
 *
 * @notes based on old globals.styles.ts file.
 *
 * @deprecated
 */
export const legacy = {
  white,
  black,

  gray50: gray[50],
  gray100: gray[100],
  gray200: gray[200],
  gray300: gray[300],
  gray400: gray[400],
  gray500: gray[500],
  gray600: gray[600],
  gray700: gray[700],
  gray800: gray[800],
  gray900: gray[900],

  darkerGray: `#222222`,
  textDisabled: gray[400],
  textSecondary: gray[600],
  textPrimary,

  disabled: gray[400],
  border: gray[400],
  divider: gray[200],
  backdrop: `rgba(0, 0, 0, 0.9)`,
  hover: `rgba(0, 0, 0, 0.04)`,
  selected: `rgba(0, 0, 0, 0.08)`,
  hoverDark: `rgba(255, 255, 255, 0.08)`,
  selectedHover: '#E5EBF1',

  // Theme colors
  error: `#de6680`,
  errorBackground: `rgba(222, 102, 128, 0.08)`,
  errorBorder: `rgba(222, 102, 128, 0.5)`,
  errorDark: `#a93554`,
  errorLight: `#ff97af`,
  errorText: `#d53d5e`,

  primary: `#2e78c7`,
  primaryBackground,
  primaryBorder: `rgba(46, 120, 199, 0.5)`,
  primaryDark: `#004d96`,
  primaryLight: `#6ba6fa`,
  primaryText: `#2e78c7`,

  success: `#00B5A0`,
  successBackground: `rgba(0, 181, 160, 0.08)`,
  successBorder: `rgba(0, 181, 160, 0.5)`,
  successDark: `#008472`,
  successLight: `#5BE8D1`,
  successText: `#008576`,

  warning: `#F59174`,
  warningBackground: `rgba(245, 145, 116, 0.08)`,
  warningBorder: `rgba(245, 145, 116, 0.5)`,
  warningDark: `#BF6248`,
  warningLight: `#FFC2A3`,
  warningText: `#DA3D10`,

  info,
  infoBackground: `rgba(3, 182, 206, 0.08)`,
  infoBorder: `rgba(3, 182, 206, 0.5)`,
  infoDark: `#00879D`,
  infoLight: `#61EAFF`,
  infoText: `#028293`,

  //  User Global Variables

  // TODO: This is out of date, update to match our semantic variables!
  // Global colors

  // Global colors
  fontName: `'Source Sans 3'`,
  yellow: `#ffc933`,
  gold: `#ffcc33`,
  fullYellow: `#ffff00`,
  red: `#de6680`,
  darkRed: `#ff2514`,
  teal: `#03B7CE`,
  deepTeal,
  green: `#00B5A0`,
  blue: `#2e78c7`,
  deepBlue: `#00648f`,

  heartColor: `#bd70a3`,

  // extended colors (These are only used in PanelMultiRunTable currently).
  seaFoamGreen: `#7ed2bf`,
  lightSeaFoamGreen: `#edf8f6`,
  slateBlue: `#68abca`,
  lightSlateBlue: `#e9f3f7`,
  lightYellowOther: `#fff2cc`,
  lightYellow: `#fffbec`,
  goldenrod: `#daa300`,

  // privacy badge colors
  fern: `#3ac26c`, // public
  aqua: `#21bfa4`, // team
  cerulean: `#37a0c7`, // private
  orchid: `#a97ccd`, // open

  lightBlue: `#ddedfc`,
  mediumBlue: `#80b3f8`,
  darkBlue: `#338dd8`,
  linkHoverBlue: `#006c95`,
  sky: `rgba(46, 120, 199, 0.08)`, // highlighted table cell
  lightSky: `#f3fafd`, // highlighted table row/col

  // Shared CSS Rules
  accordionContentPadding: `25px 20px`,
  transitionTime: `0.3s`,
  actionAnimationTime: `0.3s`,
  backgroundColorTransition: `background-color 0.3s linear`,
  borderColorTransition: `border-color 0.3s linear`,
  pillBorderRadius: `20px`,
  tabletBreakpoint: `768px`,

  tagPurple: `#e5d6ff`,
  tagBerry: `#ffd6f0`,
  tagRed: `#ffe0e0`,
  tagPeach: `#ffe7cc`,
  tagYellow: `#fde8ad`,
  tagAcid: `#c9f5b5`,
  tagGreen: `#c2f2da`,
  tagTeal: `#c0f0ed`,
  tagBlue: `#d6efff`,
  tagMidnight: `#e0e4ff`,
  tagLightBlue: `#ccf1db`,

  galleryAdminPurple: `#bd9df4`,

  commentYellow: `#FFE897`,

  // Box shadows

  // Box shadows at different levels from material
  levelNavbarBoxShadow: `0 1px 3px rgba(0, 0, 0, 0.02),
0 1px 2px rgba(0, 0, 0, 0.12)`,
  level1BoxShadow: `0 1px 3px rgba(0, 0, 0, 0.12),
0 1px 2px rgba(0, 0, 0, 0.24)`,
  level2BoxShadow: `0 3px 6px rgba(0, 0, 0, 0.16),
0 3px 6px rgba(0, 0, 0, 0.23)`,
  level3BoxShadow: `0 10px 20px rgba(0, 0, 0, 0.19),
0 6px 6px rgba(0, 0, 0, 0.23)`,
  level3BoxShadowFaint: `0 10px 20px rgba(0, 0, 0, 0.07),
0 6px 6px rgba(0, 0, 0, 0.07)`,
  level4BoxShadow: `0 14px 28px rgba(0, 0, 0, 0.25),
0 10px 10px rgba(0, 0, 0, 0.22)`,
  level5BoxShadow: `0 19px 38px rgba(0, 0, 0, 0.30),
0 15px 12px rgba(0, 0, 0, 0.22)`,

  boxShadowButtonsCharts: `0px 1px 3px 0px rgba(54,58,61,0.12)`,
  boxShadowButtonsChartsHover: `0px 3px 6px 0px rgba(54,58,61,0.12)`,
  boxShadowModal: `0px 8px 16px 0px rgba(54,58,61,0.16)`,
  boxShadowDropdown: `0px 4px 8px 0px rgba(54,58,61,0.12)`,
  boxShadowSection: `1px 1px 20px 0px #e6e6e6`,

  // Inner tab box-shadow
  tabBoxShadow: `inset 0 -4px 25px -8px rgba(0, 0, 0, 0.2)`,

  // Font sizes
  fontSizeStandard: `16px`,
  lineHeightStandard: `24px`,
  fontWeightStandard: `100`,

  // Sizes
  navbarHeight: `0px`,

  // Spacing
  pageHeaderButtonSpacing: `10px`,
  standardSpacingUnit: `8px`,
  spu: `8px`,

  // Functional Color Rules
  // These should wrap the above colors with semantic names
  // TODO: Figure out how tofontSizeStandard organize this
  // Action Colors, buttons,
  actionButtonFocusedColor: deepTeal,
  actionButtonFocusedFontColor: white,
  actionButtonFocusedBorderColor: deepTeal,

  actionButtonActiveColor: info,
  actionButtonActiveFontColor: white,
  actionButtonActiveBorderColor: info,

  actionButtonDefaultColor: gray[100],
  actionButtonDefaultFontColor: textPrimary,
  actionButtonDefaultBorderColor: `transparent`,

  actionFocusedColor: primaryBackground,
  actionFocusedFontColor: textPrimary,

  actionActiveColor: primaryBackground,
  actionActiveFontColor: textPrimary,

  separatorBorder: `1px solid ${gray[400]}`,

  searchNavHeight: `52px`,
  galleryNavHeight: `52px`,
  fancyPageSidebarWidth: `52px`,
  mobileBarHeight: `52px`,
  reportCoverHorizontalMargin: `28px`,
  reportDraftBackgroundColor: `#fff8e3`,
  reportFontSize: `18px`,

  TABLET_WIDTH: 1320,
  SMALL_TABLET_WIDTH: 1000,
  MOBILE_WIDTH: 600,
};
